import { Component, Inject, Input, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {roundOfMaxsize} from '../common/common'
import { REGISTRY_APPLICATION } from "../../../../../global/tokens";

@Component({
  selector: 'app-autoimmune-disease-chart',
  templateUrl: './autoimmune-disease-chart.component.html',
  styleUrls: ['./autoimmune-disease-chart.component.scss']
})
export class AutoimmuneDiseaseChartComponent {
  @Input() dataInsight: any;
  public loading:boolean=true

  constructor(
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if(this.application === 'Admin'){
      if (changes['dataInsight'] && changes['dataInsight'].firstChange ) {
        document.fonts.ready.then(() => {
          this.createBarChart();
          this.loading=false
        }).catch((err) => {  
          // even if the font failed to load the chart will be render
          this.createBarChart();
          this.loading=false
        });
      }
    }else{
      if (changes['dataInsight'] && !changes['dataInsight'].firstChange) {
        document.fonts.ready.then(() => {
          this.createBarChart();
          this.loading=false
        }).catch((err) => {  
          // even if the font failed to load the chart will be render
          this.createBarChart();
          this.loading=false
        });
      }
    }
    
  }

  createBarChart() {
    const labels = this.dataInsight?.autoimmune_diseases_count 
    const values = this.dataInsight?.autoimmune_diseases_count 
    const percentageValue = this.dataInsight?.autoimmune_diseases_data || [];
    // Index value to match the highlihtedBox
    const indexValue = this.dataInsight?.index;
    
    // --------------Calculate Max size----------------------------
   let {roundedMaxSize,stepSize}=roundOfMaxsize(this.dataInsight?.total_count)
    // ---------------------------------------------------------------------
    const canvas: any = document.getElementById('autoImmunebarChart');
    if (!canvas) {
      console.error('Canvas element not found');
      return;
    }
  
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = 227;
    Chart.defaults.global.defaultFontFamily= 'Poppins, sans-serif'
    new Chart(ctx, {
      type: 'horizontalBar',
      plugins: [ChartDataLabels],
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Category',
            data: values,
            backgroundColor: ['rgba(82,202,224, 1)', 'rgba(81,103, 163, 1)'],
            borderColor: ['rgba(82,202,224, 1)', 'rgba(81,103, 163, 1)'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        layout: {
          padding: {
            right: window.innerWidth >= 768 ? 74 : 70
          }
        },
        tooltips: {
          backgroundColor: 'white',
          titleFontColor: '#000',
          bodyFontColor: '#000',
          borderColor: '#ccc',
          borderWidth: 1,
          titleFontSize:window.innerWidth < 768 ? 12 : 18,
          bodyFontSize:window.innerWidth < 768 ? 12 : 16,
          callbacks: {
            label: function (tooltipItem, data) {
              const index = tooltipItem.index;
              const value = data.datasets[0].data[index] as number;
              const percentage = percentageValue[index] !== undefined ? `${percentageValue[index]}%` : "";
              return `${value} (${percentage})`;
            },
            title: function () {
              return '';
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
         datalabels: {
          display: true, // Show all labels
          color: 'rgba(81, 103, 163, 1)',
          backgroundColor: (context) => {
            const index = context.dataIndex;
            return index === indexValue ? 'white' : 'transparent';
          },
          borderRadius: (context) => {
            const index = context.dataIndex;
            return index === indexValue ? 5 : 0;
          },
          padding: (context) => {
            const index = context.dataIndex;
            return index === indexValue ? {top:6, bottom:4, left:6, right:6} : 0;
          },
          borderColor: (context) => {
            const index = context.dataIndex;
            return index === indexValue ? "rgba(153, 153, 153, 0.4)" : 'transparent';
          },
          borderWidth: (context) => {
            const index = context.dataIndex;
            return index === indexValue ? 2 : 0;
          },
          font: {
            size: window.innerWidth < 768 ? 14 : 17,
            weight: 500,
          },
          align: 'right',
          anchor: 'end',
          offset: 8,
          formatter: (value, context) => {
            const index = context.dataIndex;
            const percentage = percentageValue[index] !== undefined ? `${percentageValue[index]}%` : '';
            return percentage;
          },
          clip: false,
        }
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                beginAtZero: true,
                min: 0,
                max: roundedMaxSize,
                stepSize: stepSize,
                fontSize:window.innerWidth < 768 ? 12 : 16,
                fontColor:'rgba(65,65,65,0.8)',
                maxRotation: 45,  // rotate 45 degrees
                minRotation: 45,
              },
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Participants',
                fontSize:window.innerWidth < 768 ? 14 : 18,
                fontColor: 'rgba(62,62,62,1)',
                fontStyle:'500',
                fontFamily:"Montserrat,sans-serif"
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                display: false,
              },
              gridLines: {
                display: true,
                drawBorder: false,
                color: 'rgba(0, 0, 0, 0.1)',
                drawTicks: false,       // Hide tick marks
                zeroLineColor: 'rgba(0, 0, 0, 0.1)',
                offsetGridLines: true,  // This prevents grid lines from extending beyond the axis
              },
            },
          ],
        },
      },
    });
  }

}
